import { useDispatch } from 'react-redux'
import { DeleteFileIconSVG } from '../../../../../assets/icon/svg';
import { removeFile } from '../../../../../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.slice';
import { SupportingDocumentFile } from '../../../../../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.state';
import { getFileIcon } from '../../../../ui/get-file-icon';

interface Props {
    isPreview?: boolean;
    files: SupportingDocumentFile[];
    handleViewFile?: (filePath: string, fileName: string) => void;
    handleDownloadFile?: (filePath: string, fileName: string) => void;
}

export default function SupportingDocumentList({ isPreview, files, handleViewFile, handleDownloadFile }: Props) {
    const dispatch = useDispatch();

    const handleRemoveFile = (index: number) => {
        dispatch(removeFile(index));
    };

    const sortedFiles = [...files].sort((a, b) => {
        if (a.type === b.type) return 0;
        return a.type === "new" ? -1 : 1;
    });

    return (
        <>
            {files.length > 0 && (
                <div className={`overflow-hidden ${isPreview ? '' : 'p-2'}`}>
                    <div className="divide-y divide-gray-100">
                        {sortedFiles.map((file, index) => (
                            <div
                                key={`${file.id}-${index}`}
                                className={`flex items-center gap-2 ${isPreview ? 'px-1' : 'px-3'} py-2 transition hover:bg-gray-50`}
                            >
                                {/* FILE INFORMATION */}
                                <div className="flex min-w-0 flex-1 items-center gap-3">
                                    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-white shadow-sm">
                                        {getFileIcon(file.fileName)}
                                    </div>

                                    <div className="flex min-w-0 flex-1 items-center gap-2">
                                        <p className="min-w-0 truncate text-xs font-medium text-gray-700">
                                            {file.fileName}
                                        </p>

                                        {file.type === "new" && (
                                            <span className="shrink-0 rounded bg-green-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-green-700">
                                                New
                                            </span>
                                        )}
                                    </div>
                                </div>

                                {/* VIEW / DOWNLOAD */}
                                {isPreview && (
                                    <div className="flex shrink-0 items-center gap-1">
                                        {/* VIEW */}
                                        {/* <button
                                            onClick={() => handleDownloadFile?.(file.filePath, file.fileName)}
                                            type="button"
                                            className="inline-flex h-7 items-center gap-1 rounded-md px-2 text-[10px] font-medium text-gray-500 transition hover:bg-blue-50 hover:text-[#186cb2]"
                                            title="View document"
                                        >
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" className="h-3.5 w-3.5" aria-hidden="true">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z" />
                                                <circle cx="12" cy="12" r="2.5" />
                                            </svg>
                                            <span className="hidden sm:inline">View</span>
                                        </button> */}

                                        {/* DOWNLOAD */}
                                        <button
                                            type="button"
                                            onClick={() => handleDownloadFile?.(file.filePath, file.fileName)}
                                            className="inline-flex h-7 items-center gap-1 rounded-md px-2 text-[10px] font-medium text-gray-500 transition hover:bg-blue-50 hover:text-[#186cb2]"
                                            title="Download document"
                                        >
                                            <svg viewBox="0 0 24 24" fill="none" className="h-3.5 w-3.5" aria-hidden="true">
                                                <path d="M12 3v12m0 0 4-4m-4 4-4-4M5 21h14" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <span className="hidden sm:inline">Download</span>
                                        </button>
                                    </div>
                                )}

                                {/* DELETE */}
                                {!isPreview && file.type === "new" && (
                                    <button
                                        type="button"
                                        onClick={() => handleRemoveFile(file.id)}
                                        className="shrink-0 rounded-md p-1 text-red-500 transition hover:bg-red-50"
                                        title="Remove document"
                                    >
                                        <DeleteFileIconSVG size={18} />
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
}